import { render, staticRenderFns } from "./TextSnippet.vue?vue&type=template&id=581c01e5&scoped=true&"
import script from "./TextSnippet.vue?vue&type=script&lang=js&"
export * from "./TextSnippet.vue?vue&type=script&lang=js&"
import style0 from "./TextSnippet.vue?vue&type=style&index=0&id=581c01e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c01e5",
  null
  
)

export default component.exports